import React from 'react'

import { useQuery } from '@tanstack/react-query'
import { getCustomerAuthorizations } from 'services/customerAuthorizations'

import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import useUserForm from 'components/UserForm/useUserForm'

import { getFullName } from '@the-platform-group/formatters/people'
import useColumnConfig from '../hooks/useColumnConfig'
import USER_SCOPES from 'constants/userScopes'
import { CUSTOMER_AUTHORIZATION_QUERY_KEY, SCOPE_FIELD, ACTIVE_FIELD } from '../constants'

const UsersTable = ({ customerId }) => {
  const { handleUserEdit, getUserFormModal } = useUserForm()
  const { data, isLoading } = useQuery({
    queryKey: [CUSTOMER_AUTHORIZATION_QUERY_KEY, customerId],
    queryFn: () => getCustomerAuthorizations({ customerId }),
    select: response =>
      response.map(({ id, user, scope, lockedAt }) => ({
        id,
        name: getFullName(user),
        scope,
        isActive: !lockedAt,
        user,
      })),
    placeholderData: [],
  })

  const columns = useColumnConfig({ handleUserEdit, customerId })

  return (
    <>
      <DataGrid
        name="customerUsers"
        pagination={false}
        loading={isLoading}
        disableColumnFilter={false}
        filterMode="client"
        initialState={{
          filter: {
            filterModel: {
              items: [
                { id: 1, field: SCOPE_FIELD, value: [USER_SCOPES.user] },
                { id: 2, field: ACTIVE_FIELD, operator: 'is', value: 'true' },
              ],
            },
          },
        }}
        columns={columns}
        rows={data}
      />
      {getUserFormModal()}
    </>
  )
}

export default UsersTable
